
import React, { useState, useRef } from 'react'; 
import { BrowserRouter as Router, useHistory } from "react-router-dom";

// ... Your other imports (Home, Header, etc.) ...
import Header from "./components/Header";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Gallery from "./components/Gallery";

import Menu from "./components/Menu";
import MenuDetails from "./components/Menu/MenuDetails";
import BuildMenu from "./components/BuildMenu";

import RoutesWithKey from "./components/RoutesWithKey"; // ⬅️ MOVE ROUTES OUT


import "../src/assets/css/bootstrap.min.css";
import "../src/assets/css/meanmenu.css";
import "../src/assets/css/animate.css";
import "../src/assets/css/swiper-bundle.min.css";
import "../src/assets/css/main.css";
import "../src/assets/css/magnific-popup.css";
import "../src/assets/css/all.min.css";
import "../src/assets/css/nice-select.css";
import "../src/assets/css/decoration.css";
import "../src/assets/css/entertainment.css";
import "../src/assets/css/catering.css";
import "../src/assets/css/photography.css";

// import React, { useState, useRef } from 'react'; 
// import { BrowserRouter as Router, useHistory } from "react-router-dom";

// ... Keep your other imports (Home, Header, etc.) ...


// 1. WhatsApp Button Component
const WhatsAppButton = () => {
  const phoneNumber = "917874343757"; // 👈 REPLACE WITH YOUR NUMBER
  const message = "Hello! I am interested in your catering services.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a 
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <i className="fa-brands fa-whatsapp"></i>
      {/* <span className="tooltip-text">Chat with us</span> */}
    </a>
  );
};

const FloatingThali = () => {
  const history = useHistory();
  
  // These MUST stay inside FloatingThali
  const [position, setPosition] = useState({ x: window.innerWidth - 100, y: window.innerHeight - 150 });
  const isDragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });

  const startDrag = (clientX, clientY) => {
    isDragging.current = false; 
    dragStart.current = { x: clientX - position.x, y: clientY - position.y };
  };

  const onDrag = (clientX, clientY) => {
    isDragging.current = true;
    setPosition({
      x: clientX - dragStart.current.x,
      y: clientY - dragStart.current.y
    });
  };

  return (
    <div 
      className="special-thali-mascot"
      style={{ 
        left: `${position.x}px`, 
        top: `${position.y}px`,
        position: 'fixed',
        zIndex: 999999 // High z-index to stay on top
      }}
      onMouseDown={(e) => {
        startDrag(e.clientX, e.clientY);
        const move = (m) => onDrag(m.clientX, m.clientY);
        const stop = () => {
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', stop);
        };
        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', stop);
      }}
      onClick={() => {
        if (!isDragging.current) {
          history.push('/build-menu');
        }
      }}
    >
      <div className="thali-container">
        <img 
          src="https://cdn-icons-png.flaticon.com/512/3443/3443338.png" 
          alt="Mascot" 
          className="spinning-thali" 
        />
        <div className="chat-bubble">Build Your Thali!</div>
      </div>
    </div>
  );
};

// CLEAN APP FUNCTION
function App() {
  return (
    <Router>
      <Preloader />
       {/* IMPORTANT: Do NOT put any 'position' or 'handleMouseDown' 
        logic here. The FloatingThali component handles it all itself.
      */}
      <FloatingThali /> 
      <WhatsAppButton />

      <ScrollToTop />
      <Header />
  
      <RoutesWithKey />
      <Footer />
    </Router>
  );
}

export default App;